import React from 'react'
import PropTypes from 'prop-types'
import Dropdown from '../Dropdown/Dropdown'
import Button from '../Button/Button'
import styles from './filter.scss'

const Filter = (props) => {
  const { label, products, onHandleOptions } = props
  const hasProducts = products.length > 0
  const filterOptionsComponent = products.map((product) => {
    const { id, name, hasNotifications } = product

    return (
      <div key={id} className={styles.option}>
        {hasNotifications && (
          <Button
            id={`productFilter_${id}`}
            onClick={() => onHandleOptions && onHandleOptions(id)}
          >
            {name}
          </Button>
        )}
      </div>
    )
  })

  return (
    <div className={styles.filter}>
      <Dropdown label={label}>
        <div id="defaultOption" className={styles.option}>
          <Button onClick={() => onHandleOptions && onHandleOptions()}>
            Todos
          </Button>
        </div>
        {hasProducts && <div id="optionsList">{filterOptionsComponent}</div>}
      </Dropdown>
    </div>
  )
}

Filter.defaultProps = {
  products: [],
  label: null,
  onHandleOptions: null
}

Filter.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({})),
  label: PropTypes.string,
  onHandleOptions: PropTypes.func
}

export default Filter
